// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./scss/stiemert.scss
// module id = 1341
// module chunks = 147